import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import { Label, Segment, Table, Button, Header, Grid } from 'semantic-ui-react'

import Loading from '../../components/common/loading'
import RealTimeTracker from '../../components/common/tracker'
import DateInput from '../../components/Dashboard/DateInput'
import DownloadUpload from '../../components/Dashboard/DownloadUpload'
import CustomerMetric from '../../components/Dashboard/CustomerMetric'
import PayingCustomer from '../../components/Dashboard/PayingCustomer'

import RestaurantActions from '../../reducers/restaurantReducer'
import MenuActions from '../../reducers/menuReducer'
import MapViewActions from '../../reducers/mapViewReducer'

class Dashboard extends Component {
  constructor(props) {
    super(props)

    const allCategoriesData = {}

    _.map(props.allCategories, categories => {
      _.map(categories, (category, categoryKey) => {
        allCategoriesData[categoryKey] = category
      })
    })

    this.state = {
      partnerCluster: [],
      orderByCategory: [],
      restaurantBranchOrders: [],
      allCategoriesData,
    }
  }

  componentDidMount() {
    const { orders, getMenu, menuLoaded, getAllRestaurants, restaurantsLoaded } = this.props

    if (!restaurantsLoaded) getAllRestaurants()
    if (!menuLoaded) getMenu()

    if (_.size(orders) > 0) {
      this.handleOrderData(orders)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { orders, allCategories } = this.props

    if (nextProps.orders !== orders) {
      this.handleOrderData(nextProps.orders)
    }

    if (nextProps.allCategories !== allCategories) {
      const allCategoriesData = {}

      _.map(nextProps.allCategories, categories => {
        _.map(categories, (category, categoryKey) => {
          allCategoriesData[categoryKey] = category
        })
      })

      this.setState({ allCategoriesData })
    }
  }

  getRestoOrdersAvg(orders) {
    return parseFloat(_.mean(_.map(orders, 'sub_total'))).toFixed(2)
  }

  getRestoOrderItems(orders) {
    const eachOrderItems = _.map(orders, order => {
      return _.sumBy(_.map(order.items), item => Number(item.quantity))
    })

    return parseFloat(_.mean(eachOrderItems)).toFixed(0)
  }

  handleOrderData(orders) {
    this.generateClusterMarkers(orders)
    this.generateRestoOrders(orders)
  }

  generateClusterMarkers(orders) {
    const partnerMarkers = []

    _.map(orders, (orderObj, orderKey) => {
      const { lat: partnerLatitude, lng: partnerLongitude } = orderObj.etaInfo.info.legs[0].start_location

      partnerMarkers.push({
        latitude: partnerLatitude,
        longitude: partnerLongitude,
        orderKey,
      })
    })

    this.setState({
      partnerCluster: partnerMarkers,
    })
  }

  generateRestoOrders(orders) {
    const { allCategoriesData } = this.state
    const { restaurants } = this.props
    const orderRestaurants = _.map(orders, 'restaurant')
    const restoUniqByKeys = _.map(_.uniqBy(orderRestaurants, restaurant => restaurant.key), 'key')
    const restoUniqByBranch = _.uniqBy(orderRestaurants, restaurant => restaurant.branch.key)
    let orderByRestoBranches = {}

    const mixRestoCategory = {}
    let finalData = {}

    _.map(restoUniqByKeys, restoKey => {
      if (restaurants[restoKey] && restaurants[restoKey].categories) {
        _.map(restaurants[restoKey].categories, (category, categoryKey) => {
          mixRestoCategory[categoryKey] = {
            ...mixRestoCategory[categoryKey],
            [restoKey]: restoKey,
          }
        })
      }
    })

    _.map(restoUniqByBranch, resto => {
      orderByRestoBranches[resto.branch.key] = {
        orders: _.filter(orders, order => order.restaurant.branch.key === resto.branch.key),
        resto,
      }
    })

    _.map(mixRestoCategory, (restoKeysInCategory, categoryKey) => {
      const { name } = allCategoriesData[categoryKey] || {}
      let categoryOrders = []

      _.map(restoKeysInCategory, restoKey => {
        const restoOrders = _.filter(orders, order => order.restaurant.key === restoKey)
        categoryOrders = [...categoryOrders, ...restoOrders]
      })

      finalData[categoryKey] = {
        name,
        categoryKey,
        orders: categoryOrders,
      }
    })

    finalData = _.orderBy(finalData, data => _.size(data.orders), ['desc'])

    orderByRestoBranches = _.orderBy(orderByRestoBranches, restoObj => _.size(restoObj.orders), ['desc'])

    orderByRestoBranches = _.map(orderByRestoBranches, restoObj => {
      const avgValue = this.getRestoOrdersAvg(restoObj.orders)
      const avgItems = this.getRestoOrderItems(restoObj.orders)

      return {
        ...restoObj,
        avgValue,
        avgItems,
        success: _.filter(restoObj.orders, order => order.status === 'delivered'),
      }
    })

    this.setState({ restaurantBranchOrders: orderByRestoBranches, orderByCategory: finalData })
  }

  showCluster() {
    const { partnerCluster } = this.state
    const { setMapData } = this.props

    setMapData('merchant_zone', partnerCluster)
  }

  renderOrders() {
    const { restaurantBranchOrders } = this.state
    let no = 0

    if (_.size(restaurantBranchOrders) > 0) {
      return _.map(restaurantBranchOrders, restoObj => {
        no += 1
        return (
          <Table.Row key={restoObj.resto.branch.key}>
            <Table.Cell>{`${no}. ${restoObj.resto.name}`}</Table.Cell>
            <Table.Cell textAlign="center">
              <Label>{restoObj.resto.branch.name}</Label>
            </Table.Cell>
            <Table.Cell textAlign="center">
              <Label circular style={{ fontSize: 13 }}>
                {_.size(restoObj.success)} / {_.size(restoObj.orders)}
              </Label>
            </Table.Cell>
            <Table.Cell textAlign="right">{`${restoObj.avgItems || 0}`}</Table.Cell>
            <Table.Cell textAlign="right">{`$ ${restoObj.avgValue || 0}`}</Table.Cell>
          </Table.Row>
        )
      })
    }

    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan="5">
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  renderCategoryOrders() {
    const { orderByCategory } = this.state

    if (_.size(orderByCategory) > 0) {
      let no = 0
      return _.map(orderByCategory, categoryObj => {
        const avgValue = this.getRestoOrdersAvg(categoryObj.orders)
        no += 1
        return (
          <Table.Row key={categoryObj.categoryKey}>
            <Table.Cell>{`${no}. ${categoryObj.name}`}</Table.Cell>
            <Table.Cell textAlign="center">
              <Label circular>{_.size(categoryObj.orders)}</Label>
            </Table.Cell>
            <Table.Cell textAlign="right">{`$ ${avgValue || 0}`}</Table.Cell>
          </Table.Row>
        )
      })
    }

    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan="3">
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { partnerCluster } = this.state
    const { orders, expressOrders, restaurantsLoading, menuLoading } = this.props

    return (
      <div style={{ paddingBottom: 50 }}>
        <Loading active={restaurantsLoading || menuLoading} />
        <Segment>
          <Grid columns="equal">
            <Grid.Column>
              <DateInput />
              <DownloadUpload />
            </Grid.Column>
          </Grid>
        </Segment>
        <Grid columns="equal">
          <Grid.Column>
            <RealTimeTracker
              type="order"
              label="Orders"
              icon="shop"
              data={orders}
              loaded
              fetch={() => {}}
              loading={false}
            />
          </Grid.Column>
          <Grid.Column>
            <RealTimeTracker
              type="express_order"
              label="Express Orders"
              icon="motorcycle"
              data={expressOrders}
              loaded
              fetch={() => {}}
              loading={false}
            />
          </Grid.Column>
        </Grid>

        <CustomerMetric />
        <PayingCustomer />

        <Segment>
          <Header size="large">
            Partner
            <Button
              style={{ float: 'right' }}
              onClick={() => this.showCluster('restaurant')}
              disabled={_.size(partnerCluster) === 0}
            >
              Restaurant Zone
            </Button>
          </Header>

          <Grid columns="equal" style={{ marginTop: 10 }}>
            <Grid.Column>
              <Segment style={{ maxHeight: 700, overflow: 'auto' }}>
                <Table basic="very">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell textAlign="left">Restaurant Name</Table.HeaderCell>
                      <Table.HeaderCell width={4} textAlign="center">
                        Branch
                      </Table.HeaderCell>
                      <Table.HeaderCell width={2} textAlign="center">
                        Orders
                      </Table.HeaderCell>
                      <Table.HeaderCell width={3} textAlign="right">
                        Items (AVG)
                      </Table.HeaderCell>
                      <Table.HeaderCell width={3} textAlign="right">
                        Amount (AVG)
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>{this.renderOrders()}</Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment style={{ maxHeight: 700, overflow: 'auto' }}>
                <Table basic="very">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell textAlign="left">Category Name</Table.HeaderCell>
                      <Table.HeaderCell width={2} textAlign="center">
                        Orders
                      </Table.HeaderCell>
                      <Table.HeaderCell width={3} textAlign="right">
                        Amount (AVG)
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>{this.renderCategoryOrders()}</Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
          </Grid>
        </Segment>
      </div>
    )
  }
}

const mapState = ({ menus, restaurants, dashboard }) => ({
  orders: dashboard.dashboardOrders,
  restaurants: restaurants.data,
  restaurantsLoaded: restaurants.loaded,
  restaurantsLoading: restaurants.loading,
  menu: menus.data,
  menuLoaded: menus.loaded,
  menuLoading: menus.loading,
  allCategories: _.map(menus.data, menu => menu.categories),
  expressOrders: dashboard.expressOrders,
})

const mapDispatch = {
  getAllRestaurants: RestaurantActions.fetchRestaurantsRequest,
  getMenu: MenuActions.fetchMenusRequest,
  setMapData: MapViewActions.setMapData,
}

export default connect(
  mapState,
  mapDispatch
)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/dashboard/index.js